import React from "react";
import { Container, Row, Col, Button } from "reactstrap";
import ScrollAnimation from "react-animate-on-scroll";

function WhoSponsor() {
  return (
    <>
      <div
        style={{
          backgroundColor: "transparent",
          // backgroundImage: `url(${svg})`,
          // backgroundPosition: "top right",
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "100%",
        }}
        className="section py-0"
        data-parallax={true}
      >
        <Container>
          <Row>
            <Col lg={12} className="my-5">
              <h5 className="text-400 text-white mt-0">
                Position your brand at the epicenter of fintech and digital banking innovation
                across the Middle East. With exponential demand for smart, secure, and scalable
                financial solutions, Finnovex Middle East 2025 provides the perfect platform to
                amplify your visibility, influence key stakeholders, and drive ROI.
              </h5>
            </Col>
          </Row>
        </Container>
        <Container>
          <Row>
            <Col lg={12}>
              <h2
                className="text-white mt-3 text-700 text-center mb-5"
                style={{ color: "#003972" }}
              >
                Top Reasons To Sponsor
              </h2>
            </Col>
            {content.map((s, i) => (
              <>
                <Col lg={6} className="mb-5 align-self-center">
                  <ScrollAnimation animateIn={"fadeInDown"} animateOnce={true} duration={1.5}>
                    <h2 className="text-white text-700">{s.title}</h2>
                    <h3 className="text-white text-400 mt-2">{s.description}</h3>
                  </ScrollAnimation>
                </Col>
                <Col lg={6} className="mb-5">
                  <ScrollAnimation animateIn={"fadeInDown"} animateOnce={true} duration={1.5}>
                    <img src={require(`assets/quotes/${i + 1}.jpg`)} width="100%" alt="main logo" />
                  </ScrollAnimation>
                </Col>
              </>
            ))}
          </Row>
          <Row className="justify-content-center">
            <Col md={12} xs={12} className="mb-1 mt-3">
              <Container fluid>
                <Row>
                  <Col lg={4} xs={12} className={`px-1`}>
                    <Button className="px-3 py-2 my-5 rounded-0" color="primary" href="/register">
                      <p className="m-0 text-700" style={{ color: "#fff" }}>
                        Get a Sponsorship Kit
                      </p>
                    </Button>{" "}
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </div>
      <div
        style={{
          backgroundColor: "transparent",
        }}
        className="section py-0"
        data-parallax={true}
      >
        <Container>
          <Row>
            <Col lg={12} className="mt-5 text-center p-3 mb-4">
              <h5 className="text-400 mt-0 text-white p-3">
                Sponsorship offers a unique opportunity to set your brand apart and connect with
                senior buyers from the financial services industry. Benefit from our comprehensive
                delegate research, cutting-edge insights, and extensive network to elevate your
                brand in the Middle East.
                <br />
                <br />
                Contact us today at{" "}
                <a href="mailto:info@exibex.com" className="text-primary">
                  <b>info@exibex.com</b>
                </a>{" "}
                or call us on{" "}
                <a href="tel:+971 585518437" className="text-primary">
                  <b>+971 585518437</b> /
                </a>{" "}
                <a href="tel:+91 9980028128" className="text-primary">
                  <b>+91 9980028128</b>
                </a>{" "}
                to learn more. Our team is ready to help you seize this opportunity and make a
                powerful impact in your industry. Let's take your brand to the top together!
              </h5>

              <br />
              <Container>
                <Row className="justify-content-center">
                  <Col lg={4}>
                    <Button
                      href="mailto:info@exibex.com"
                      className="btn my-2 text-center px-5"
                      color="primary"
                      size="lg"
                    >
                      Contact Us
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default WhoSponsor;

const content = [
  {
    title: "Engage with Key Stakeholders",
    description:
      "Gain direct access to senior banking professionals, government leaders, and tech buyers actively seeking new partnerships and solutions.",
    image: "one.ong",
  },
  {
    title: "Customize Your Experience",
    description:
      "From curated panels to private roundtables, we offer tailored packages that help your brand stand out and speak to the right audience.",
    image: "competition.ong",
  },
  {
    title: "Strengthen Your Market Leadership",
    description:
      "Position your organization as a thought leader and innovation partner in one of the fastest-growing financial markets globally.",
    image: "showcase.ong",
  },
];
